<div
  class="component-container text-cool-grey h-[100%] flex flex-col justify-center items-center p-[6.4rem]">
  <div class="reset-password-form-container md:w-[80%] w-full">
    <div class="heading font-bold font-poppins  mb-[2.4rem] text-center">
      Reset your Password?
    </div>
    <form>
      <app-password-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['password']"
        [parentFormGroup]="form"
        [tooltip]="true"
        controlName="password"
        label="Password"
        placeholder="Password"
        type="small"
      ></app-password-input>
      <app-password-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['confirmPassword']"
        [parentFormGroup]="form"
        controlName="confirmPassword"
        label="Confirm Password"
        placeholder="Confirm Password"
        type="small"
      ></app-password-input>
      <div class="actions-section mt-[1rem]">
        <app-primary-button
          (click)="resetPassword()"
          type="small"
        >
          RESET PASSWORD
        </app-primary-button>
      </div>
    </form>
  </div>
</div>
